import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';

function List() {

    const pathFrontEnd = '/documenttypes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}documenttypes/delete`,
        endpoint: config.endpoints.backend + 'documenttypes/getall'
    }

    let list = {
        labelTitle: 'Lista de Tipos de Documento',
        labelTitleButtonAdd: 'Incluir novo tipo',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        columns: [
            {
                name: 'name',
                label: 'Nome do tipo de documento'
            },
            {
                name: 'category',
                label: 'Categoria'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
